module.exports = __webpack_public_path__ + "img/teamwork-icon-11.1759b7ae.png";